// extracted by mini-css-extract-plugin
export default {"container":"AddedWalletBox_container__TJ9DI","edit":"AddedWalletBox_edit__BJW7q","name":"AddedWalletBox_name__EWQS+"};